import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { RootState } from '@/store/types'
import { getSubscriptions, type ISubscriptionPackage } from '@/api/subscriptions'

interface ISubscriptionsState {
  packages: ISubscriptionPackage[]
  loaded: boolean
  loading: boolean
}

const initialState: ISubscriptionsState = {
  packages: [],
  loaded: false,
  loading: false
}

export const fetchSubscriptions = createAsyncThunk<ISubscriptionPackage[], void, { state: RootState }>(
  'subscriptions/fetch',
  () => getSubscriptions(),
  {
    condition: (_, { getState }) => !getState().subscriptions.loading
  }
)

const subscriptions = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSubscriptions.pending, state => {
        state.loading = true
      })
      .addCase(fetchSubscriptions.fulfilled, (state, { payload }) => {
        state.packages = payload
        state.loaded = true
        state.loading = false
      })
      .addCase(fetchSubscriptions.rejected, state => {
        state.loading = false
      })
  }
})

export default subscriptions.reducer
